import PropTypes from 'prop-types';

function AppNotificationReducer(state = {}, action) {

  switch (action.type) {
    case 'SET_NOTIFICATION':
      return {
        ...state,
        notification: action.payload,
      };
    default:
      return state;
  }
}

AppNotificationReducer.propTypes = {
  state: PropTypes.shape({}),
  action: PropTypes.shape({
    type: PropTypes.string,
  }),
};

function getNotification(state) {
  return state.AppNotificationReducer.notification;
}

export { AppNotificationReducer, getNotification };
